<template>
  <div>
    <ApartmentCard
      v-if="apartment"
      :apartment="apartment"
    />
  </div>
</template>

<script>
  import ApartmentCard from './components/ApartmentCard';
  import getApartment, {notFound} from '../lib/getApartment';

  export default {
    components: {
      ApartmentCard,
    },
    props: {
      uuid: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        error: false,
        apartment: null,
      };
    },
    async mounted() {
      const apartment = await getApartment(this.uuid);
      if (apartment === notFound || !apartment.available) {
        this.error = true;
        return;
      }
      this.apartment = apartment;
    },
  };
</script>
